<div class="p-4">
  <div>
    <div class="font-bold text-4xl">山留凡例</div>
    <div class="pl-8 pt-4 pb-4 text-2xl w-full">
      <div class="border-1 border-black border-solid">
        <div class="w-full flex">
          <div class="p-2 border-1 border-black border-solid">
            <span class="global-status-signal-20">・</span>
          </div>
          <div class="p-2 w-1/6 border-1 border-black border-solid">危険</div>
          <div class="p-2 w-1/2 border-1 border-black border-solid">
            基準値超過
          </div>
        </div>

        <div class="w-full flex">
          <div class="p-2 border-1 border-black border-solid">
            <span class="global-status-signal-3">・</span>
          </div>
          <div class="p-2 w-1/6 border-1 border-black border-solid">注意</div>
          <div class="p-2 w-1/2 border-1 border-black border-solid">
            基準値80%超過
          </div>
        </div>

        <div class="w-full flex">
          <div class="p-2 border-1 border-black border-solid">
            <span class="global-status-signal-1">・</span>
          </div>
          <div class="p-2 w-1/6 border-1 border-black border-solid">安全</div>
          <div class="p-2 w-1/2 border-1 border-black border-solid">
            基準値範囲内
          </div>
        </div>

        <div class="w-full flex">
          <div class="p-2 border-1 border-black border-solid">
            <span class="global-status-signal-99">・</span>
          </div>
          <div class="p-2 w-1/6 border-1 border-black border-solid">停止</div>
          <div class="p-2 w-1/2 border-1 border-black border-solid">
            信号なし又はセンサー未設定
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
